export default "__VITE_ASSET__oGY4VIonS4rqUFJ_RZFJYg__"